import React from "react";

export enum HostClientType {
	desktop = "desktop",
	web = "web",
	android = "android",
	ios = "ios",
	ipados = "ipados",
	macos = "macos",
	/**
	 * @deprecated
	 * As of 2.0.0, please use {@link teamsRoomsWindows} instead.
	 */
	rigel = "rigel",
	surfaceHub = "surfaceHub",
	teamsRoomsWindows = "teamsRoomsWindows",
	teamsRoomsAndroid = "teamsRoomsAndroid",
	teamsPhones = "teamsPhones",
	teamsDisplays = "teamsDisplays",
}

export enum FrameContexts {
	settings = "settings",
	content = "content",
	authentication = "authentication",
	remove = "remove",
	task = "task",
	sidePanel = "sidePanel",
	stage = "stage",
	meetingStage = "meetingStage",
}

export interface MinimalTeamsContext {
	/**
	 * The current UI theme.
	 */
	theme: string;

	/**
	 * Indication whether the tab is in full-screen mode.
	 */
	isFullScreen: boolean;

	/**
	 * Indication whether the tab is loaded in the side-panel (narrow view).
	 */
	isTeamsSidePanel: boolean;

	/**
	 * Unique ID for the current Teams session for use in correlating telemetry data.
	 */
	sessionId: string;

	/**
	 * The type of the host client. Possible values include : android, ios, ipados, macos, web, desktop, rigel
	 */
	hostClientType: HostClientType;

	/**
	 * The context where tab url is loaded (content, task, setting, remove, sidePanel)
	 */
	frameContext: FrameContexts;

	/**
	 * Meeting Id used by tab when running in meeting context
	 */
	meetingId?: string;

	/**
	 * execute deep link API.
	 * @param deepLink deep link.
	 */
	executeDeepLink: (deepLink: string, onComplete?: (status: boolean, reason?: string) => void) => void;
}

export const TeamsContext = React.createContext<MinimalTeamsContext | undefined>(undefined);
TeamsContext.displayName = "TeamsContext";
